import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconBorderInnerComponent } from "./med-icon-border-inner.component";

@NgModule({
  declarations: [
    MedIconBorderInnerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconBorderInnerComponent,
  ],
})
export class MedIconBorderInnerModule { }
